import React, { useEffect } from "react";
import { Col, Row, Image } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@mui/material';
import { HelpOutlined as HelpOutlinedIcon } from '@mui/icons-material';
import { Info as InfoIcon } from '@mui/icons-material';
import { customValidators, object, string } from '../../../Helpers/Validators/customValidators';
import { SelectInput, TextInput, StyledRadioInput } from "../../../Helpers/Inputs";
import { InputMaskZip } from '../../../Helpers/Formatters';
import TimeZones from '../../Common/Appointment/Timezones';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.jsx';
import StatesWithDisabled from '../../../Helpers/Lists/StatesWithDisabled';
import States from '../../../Helpers/Lists/States';
import Step2Icon from '../icons/step_2.svg?react';
import IconHolder from "../../../Helpers/IconHolder";
import { SESSION_STORAGE_ANALYSIS_KEY, getSessionStorageItem } from "../../../../sessionStorage.jsx";

export default function GettingToKnowYou(props) {
  const { setValue, trigger, register } = props;

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
    trigger(field);
  };

  useEffect(() => {
    register('mailingState');
    setValue('mailingState', props.basicInfo.state);

    register('state');
    setValue('state', props.basicInfo.state);
  }, [register]);

  //running onfieldchange for each causes race conditions
  useEffect(() => {
    const form = { ...props.fullFormState };
    form.steps.gettingToKnowYou.mailingState = props.basicInfo.state;
    form.steps.gettingToKnowYou.state = props.basicInfo.state;
    const analysisInfo = getSessionStorageItem(SESSION_STORAGE_ANALYSIS_KEY);
    if (analysisInfo && analysisInfo.maritalStatus && (form.steps.gettingToKnowYou.maritalStatus === null || form.steps.gettingToKnowYou.maritalStatus === "")) {
      const analysisMaritalStatus = analysisInfo.maritalStatus.toLowerCase();
      setValue('maritalStatus', analysisMaritalStatus);
      form.steps.gettingToKnowYou.maritalStatus = analysisMaritalStatus;
    }
    props.onMultiFieldChange(form);
  }, []);

  const label = (
    <span>
      <Tooltip
        title="The owner of a policy is the one who makes the premium payments and assigns the beneficiary. The insured is the individual who is covered under the policy."
        placement="top"
        enterTouchDelay={0}
        slotProps={{
          tooltip: {
            className: 'light-tooltip',
            sx: { fontSize: '14px' }
          },
        }}>
        <InfoIcon className="me-2 " />
      </Tooltip>Is the proposed insured also the owner of the policy?
    </span>);

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <IconHolder icon={Step2Icon} viewBox="0 0 25 25" color='primary' />
      </Row>
      <h4 className="headerTitle">Review Marital and Residential Status</h4>
      <h5 className="headerSubtitle">Please complete this information as part of the application process.</h5>
      <br />
      <StyledRadioInput
        name="maritalStatus"
        id="maritalStatus"
        value={props.formState.maritalStatus}
        label="Are you single or married ?"
        options={[
          { value: "single", label: "Single" },
          { value: "married", label: "Married" }]}
        onChange={e => handleValueChange('maritalStatus', e)}
      />
      <h6>Street Address</h6>
      <div className="mb-3">
        <TextInput
          name="street"
          id="street"
          label="Address"
          value={props.formState.street}
          onChange={e => props.onFieldChange('street', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name="city"
          id="city"
          label="City"
          value={props.formState.city}
          onChange={e => props.onFieldChange('city', e.target.value)}
        />
      </div>

      <Row>
        <Col>
          <SelectInput
            name="state"
            id="state"
            value={props.formState.state}
            onChange={(e) => handleValueChange('state', e.target.value)}
            label="State"
            selectOptions={StatesWithDisabled(["NY"])}
            disabled
          />
        </Col>
        <Col>
          <div className="mb-3">
            <TextInput
              name="zip"
              id="zip"
              label="Zip"
              value={props.formState.zip}
              onChange={e => props.onFieldChange('zip', e.target.value)}
              InputProps={{
                inputComponent: InputMaskZip,
              }}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="mb-3">
            <SelectInput
              name="timeZone"
              id="timeZone"
              value={props.formState.timeZone}
              onChange={(e) => handleValueChange('timeZone', e.target.value)}
              label="Timezone"
              selectOptions={TimeZones}
            />
          </div>
        </Col>
      </Row>

      <StyledRadioInput
        name="sameAsStreetAddress"
        id="sameAsStreetAddress"
        label="Is the mailing address the same as the street address?"
        value={props.formState.sameAsStreetAddress}
        options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
        onChange={e => handleValueChange('sameAsStreetAddress', e)}
      />

      {props.formState.sameAsStreetAddress === "false" &&
        <React.Fragment>
          <h6>Mailing Address</h6>

          <StyledRadioInput
            name="mailingAdressISPOBox"
            id="mailingAdressISPOBox"
            label="Is the mailing address a PO Box?"
            value={props.formState.mailingAdressISPOBox}
            options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
            onChange={e => handleValueChange('mailingAdressISPOBox', e)}
          />

          <div className="mb-3">
            <TextInput
              name="mailingStreet"
              id="mailingStreet"
              label="Mailing Address"
              value={props.formState.mailingStreet}
              onChange={e => props.onFieldChange('mailingStreet', e.target.value)}
            />
          </div>

          <div className="mb-3">
            <TextInput
              name="mailingCity"
              id="mailingCity"
              label="Mailing City"
              value={props.formState.mailingCity}
              onChange={e => props.onFieldChange('mailingCity', e.target.value)}
            />
          </div>

          <Row>
            <Col>
              <div className="mb-3">
                <SelectInput
                  name="mailingState"
                  id="mailingState"
                  value={props.formState.mailingState}
                  onChange={(e) => handleValueChange('mailingState', e.target.value)}
                  label="Mailing State"
                  selectOptions={StatesWithDisabled(["NY"])}
                />
              </div>
            </Col>
            <Col>
              <div className="mb-3">
                <TextInput
                  name="mailingZip"
                  id="mailingZip"
                  label="Mailing Zip"
                  value={props.formState.mailingZip}
                  onChange={e => props.onFieldChange('mailingZip', e.target.value)}
                  InputProps={{
                    inputComponent: InputMaskZip,
                  }}
                />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      }

      <div className="mb-3">
        <StyledRadioInput
          name="residenceLessThanFive"
          id="residenceLessThanFive"
          label="Has the proposed insured lived at their current address for at least 5 years?"
          value={props.formState.residenceLessThanFive}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('residenceLessThanFive', e)}
        />
      </div>

      {props.formState.residenceLessThanFive === "false" &&
        <div className="mb-3">
          <TextInput
            name="insuredPriorZip"
            id="insuredPriorZip"
            label="What is the Proposed Insured's prior zip code?"
            value={props.formState.insuredPriorZip}
            onChange={e => props.onFieldChange('insuredPriorZip', e.target.value)}
            InputProps={{
              inputComponent: InputMaskZip,
            }}
          />
        </div>
      }

      <div className="mb-3">
        <StyledRadioInput
          name="ownerIsProposedInsured"
          id="ownerIsProposedInsured"
          label={label}
          value={props.formState.ownerIsProposedInsured}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('ownerIsProposedInsured', e)}
        />
      </div>

      <div className="mb-3">
        <StyledRadioInput
          name="proposedInsuredIsUSCitizen"
          id="proposedInsuredIsUSCitizen"
          label="Is the Proposed Insured a US citizen?"
          value={props.formState.proposedInsuredIsUSCitizen}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('proposedInsuredIsUSCitizen', e)}
        />
      </div>

      {props.formState.proposedInsuredIsUSCitizen === "false" && (
        <div>
          <div className="mb-3">
            <StyledRadioInput
              name="proposedInsuredIsPermanentResident"
              id="proposedInsuredIsPermanentResident"
              label="Is the Proposed Insured a Permanent Resident?"
              value={props.formState.proposedInsuredIsPermanentResident}
              options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
              onChange={e => handleValueChange('proposedInsuredIsPermanentResident', e)}
            />
          </div>

          {props.formState.proposedInsuredIsPermanentResident === "true" && (
            <div>
              <div className="text-center mb-4">
                <Image src={`${process.env.PUBLIC_URL}/americo/Green-Card.jpg`} alt={'Green Card Logo'} />
              </div>
              <div className="mb-3">
                <TextInput
                  name="visaGreenCardId"
                  id="visaGreenCardId"
                  label="Permanent Resident Visa or Green Card ID #"
                  value={props.formState.visaGreenCardId}
                  onChange={e => props.onFieldChange('visaGreenCardId', e.target.value)}
                />
              </div>
              <div className="mb-3">
                A copy of the Permanent Resident Visa or Green Card must be provided to underwriting as a delivery requirement. Please send by email to <a href="mailto:submit@americo.com">submit@americo.com</a> or by fax to 800-395-9261.
                <IconButton aria-label="help" size="small">
                  <HelpOutlinedIcon />
                </IconButton>
              </div>
            </div>
          )}
        </div>
      )}

      {props.formState.proposedInsuredIsUSCitizen === "true" && (
        <div className="mb-3">
          <SelectInput
            name="insuredStateOfBirth"
            id="insuredStateOfBirth"
            value={props.formState.insuredStateOfBirth}
            onChange={(e) => handleValueChange('insuredStateOfBirth', e.target.value)}
            label="Birth State"
            selectOptions={[...States(), { label: 'Foreign Country', value: 'Foreign Country' }]}
          />
        </div>
      )}
    </React.Fragment>
  );
}

GettingToKnowYou.ValidationSchema = () => {
  return object().shape({
    maritalStatus: string()
      .required('Marital status is required.'),
    sameAsStreetAddress: string().required('This field is required.'),
    mailingAdressISPOBox: string().when("sameAsStreetAddress", {
      is: "false",
      then: (schema) => schema.required('This field is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),
    mailingStreet: customValidators.string().when("sameAsStreetAddress", {
      is: "false",
      then: (schema) => schema.isValidNameLimitedSpecialChar('Mailing street address is required.', true, true),
      otherwise: (schema) => schema.notRequired(),
    }),
    mailingCity: string().when("sameAsStreetAddress", {
      is: "false",
      then: (schema) => schema.isValidNameLimitedSpecialChar('Mailing city is required.', true, false),
      otherwise: (schema) => schema.notRequired(),
    }),
    mailingState: string().when("sameAsStreetAddress", {
      is: "false",
      then: (schema) => schema.required('Mailing state is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),
    mailingZip: customValidators.string().when("sameAsStreetAddress", {
      is: "false",
      then: (schema) => schema.isValidNumbersOnly('Invalid zip', 5).required('Mailing zip is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),
    street: customValidators.string().isValidNameLimitedSpecialChar('Street address is required.', true, true),
    city: string().isValidNameLimitedSpecialChar('City is required.', true, false),
    state: string()
      .required('State is required.'),
    zip: customValidators.string()
      .isValidNumbersOnly('Invalid zip.', 5)
      .required('Zip is required.'),
    residenceLessThanFive: string()
      .required('This field is required.'),
    insuredPriorZip: customValidators.string().when('residenceLessThanFive', {
      is: "false",
      then: (schema) => schema.isValidNumbersOnly('Invalid zip.', 5).required('Zip is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),
    ownerIsProposedInsured: string().required('This field is required.'),
    proposedInsuredIsUSCitizen: string().required("This field is required."),
    proposedInsuredIsPermanentResident: string().when('proposedInsuredIsUSCitizen', {
      is: "false",
      then: (schema) => schema.required("This field is required."),
      otherwise: (schema) => schema.notRequired(),
    }),
    visaGreenCardId: customValidators.string().when(
      ['proposedInsuredIsUSCitizen', 'proposedInsuredIsPermanentResident'],
      ([proposedInsuredIsUSCitizen, proposedInsuredIsPermanentResident], schema) => {
        return proposedInsuredIsUSCitizen === "false" && proposedInsuredIsPermanentResident === "true"
          ? schema.required("Visa/Green Card number is required.").isValidVisaNumber('Please re-enter a valid Visa/Green Card number.')
          : string().notRequired();
      }
    ),
    insuredStateOfBirth: string().when('proposedInsuredIsUSCitizen', {
      is: "true",
      then: (schema) => schema.required("State of birth is required."),
      otherwise: (schema) => schema.notRequired(),
    }),
    timeZone: string().transform(emptyStringToUndefined).required("Timezone is required."),
  });
};

GettingToKnowYou.DefaultFormState = (prefill = false, basicInfo = null, analysisInfo = null) => {

  let usResident = "";
  if (basicInfo && basicInfo.usResident === true) {
    usResident = "true";
  } else if (basicInfo && basicInfo.usResident === false) {
    usResident = "false";
  }

  return {
    maritalStatus: prefill ? "married" : (analysisInfo && analysisInfo.maritalStatus) ? analysisInfo.maritalStatus.toLowerCase() : "",
    mailingAdressISPOBox: "false",
    sameAsStreetAddress: "true",
    street: prefill ? "2020 Covr St" : "",
    city: prefill ? "Boise" : "",
    state: prefill ? "ID" : "",
    zip: prefill ? "83702" : "",
    mailingStreet: prefill ? "2020 Covr St" : "",
    mailingCity: prefill ? "Boise" : "",
    mailingZip: prefill ? "83702" : "",
    mailingState: prefill ? "ID" : "",
    residenceLessThanFive: prefill ? "false" : "",
    insuredPriorZip: prefill ? "83702" : "",
    ownerIsProposedInsured: prefill ? "true" : "",
    proposedInsuredIsUSCitizen: prefill ? "true" : usResident,
    proposedInsuredIsPermanentResident: prefill ? "true" : (usResident === "true" ? "" : usResident),
    visaGreenCardId: prefill ? "ABC1234567890" : "",
    insuredStateOfBirth: prefill ? "ID" : "",
    timeZone: (function () {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tz1 = TimeZones.find(e => e.zone === tz);
      return tz1 ? tz1.value : '';
    })(),
  };
};

GettingToKnowYou.propTypes = {
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  fullFormState: PropTypes.object,
  basicInfo: PropTypes.object,
  onMultiFieldChange: PropTypes.func,
  setValue: PropTypes.func,
  trigger: PropTypes.func,
};
